import React, { useState } from 'react';
import { Button } from './ui/button';
import { CheckCircle2, Phone, Shield } from 'lucide-react';
import LeadForm from './LeadForm';
import GoogleBadge from './GoogleBadge';

const HeroSection = () => {
  return (
    <section className="hero-section">
      <div className="hero-background"></div>
      <div className="container-custom">
        <div className="hero-content">
          <div className="hero-text fade-in">
            <h1 className="headline-primary" style={{ 
              fontSize: 'clamp(3.75rem, 7.5vw, 6rem)',
              fontFamily: "'Dancing Script', 'Brush Script MT', cursive",
              fontWeight: 700,
              lineHeight: 1.1,
              marginBottom: '2rem'
            }}>
              Würdevoll Abschied nehmen.<br />
              Angehörige entlasten.
            </h1>
            <p className="subheadline">
              Mit einer Sterbegeldversicherung sichern Sie Ihre Bestattungskosten ab und schenken 
              Ihren Liebsten in schweren Stunden finanzielle Sicherheit und emotionale Entlastung.
            </p>
            
            <ul className="hero-benefits">
              <li>
                <CheckCircle2 className="icon" />
                <span>Finanzielle Sicherheit für würdevolle Bestattung</span>
              </li>
              <li>
                <CheckCircle2 className="icon" />
                <span>Persönliche Beratung durch Vorsorge-Experten</span>
              </li>
              <li>
                <CheckCircle2 className="icon" />
                <span>Transparente Lösungen ohne versteckte Kosten</span>
              </li>
            </ul>

            <div className="trust-badges">
              <div className="trust-badge">
                <Shield className="icon" />
                <span>100% Datensicherheit</span>
              </div>
              <div className="trust-badge">
                <CheckCircle2 className="icon" />
                <span>Unverbindliche Beratung</span>
              </div>
              <div className="trust-badge">
                <Phone className="icon" />
                <span>Persönliche Ansprechpartner</span>
              </div>
            </div>
          </div>

          <div className="hero-form-container fade-in">
            <LeadForm />
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
